/*
 * di-matiere-tiers.js — sélecteur Matière à deux niveaux (Type / Finition)
 *
 * Demandé par Romy le 2026-08-17. Purement cosmétique : les vraies pilules rendues par
 * snippets/swatch.liquid restent dans le DOM (.di-matiere-raw) et continuent de piloter les
 * variantes Shopify via diSwatchElem(). Ce script construit deux rangées par-dessus et masque
 * les pilules d'origine. Si le script ne charge pas, les pilules d'origine restent visibles
 * et fonctionnelles — aucune régression possible.
 *
 * ⚠️ Corrigé le 2026-08-30 : le premier jet (17 août) supposait un lancement à 2 finitions
 * traditionnelles (Régulier/Commercial, mappées sur Texturé/Lisse). Vincent a confirmé le
 * 30 août que le scope reste bien les 3 finitions du plan du 14 août — Fibreux, Satiné,
 * Commercial — qui sont 3 matières distinctes, pas des variantes lisse/texturé d'un même
 * papier. Le niveau 2 (Finition) dépend donc du niveau 1 (Type) au lieu d'être un ensemble
 * fixe partagé par tous les types :
 *   Autocollant   -> Lisse, Texturé
 *   Traditionnel  -> Fibreux, Satiné, Commercial
 * La correspondance réelle est calculée à partir des variantes du produit, pas codée en dur ici —
 * elle arrive dans data-di-matiere, généré par swatch.liquid.
 */
(function () {
  'use strict';

  var TYPE_ORDER = ['autocollant', 'traditionnel'];
  var FINI_ORDER_BY_TYPE = {
    autocollant: ['lisse', 'texture'],
    traditionnel: ['fibreux', 'satine', 'commercial']
  };

  function parseData(raw) {
    var out = [];
    (raw || '').split('~~').forEach(function (chunk) {
      if (!chunk) return;
      var parts = chunk.split('|');
      if (parts.length !== 3) return;
      out.push({ value: parts[0], type: parts[1], fini: parts[2] });
    });
    return out;
  }

  function makePill(label, group, key) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'di-tier-pill';
    el.setAttribute('data-di-group', group);
    el.setAttribute('data-di-key', key);
    el.textContent = label;
    return el;
  }

  function makeRow(labelText) {
    var wrap = document.createElement('div');
    wrap.className = 'di-tier-block';
    var label = document.createElement('span');
    label.className = 'di-tier-label';
    label.textContent = labelText;
    var row = document.createElement('div');
    row.className = 'di-tier-row';
    wrap.appendChild(label);
    wrap.appendChild(row);
    return { wrap: wrap, row: row };
  }

  function init(host) {
    var entries = parseData(host.getAttribute('data-di-matiere'));
    if (entries.length < 2) return;

    var swatch = host.closest('.swatch');
    if (!swatch) return;
    var rawBox = swatch.querySelector('.di-matiere-raw');
    if (!rawBox) return;

    var names = {
      autocollant: host.getAttribute('data-name-autocollant') || 'Autocollant',
      traditionnel: host.getAttribute('data-name-traditionnel') || 'Traditionnel',
      lisse: host.getAttribute('data-name-lisse') || 'Lisse',
      texture: host.getAttribute('data-name-texture') || 'Texturé',
      fibreux: host.getAttribute('data-name-fibreux') || 'Fibreux',
      satine: host.getAttribute('data-name-satine') || 'Satiné',
      commercial: host.getAttribute('data-name-commercial') || 'Commercial'
    };

    // Types présents, dans l'ordre voulu (pas l'ordre des variantes Shopify)
    var types = TYPE_ORDER.filter(function (t) {
      return entries.some(function (e) { return e.type === t; });
    });
    if (types.length === 0) return;

    var typeBlock = makeRow(host.getAttribute('data-label-type') || 'Papier peint');
    var finiBlock = makeRow(host.getAttribute('data-label-fini') || 'Fini');

    types.forEach(function (t) {
      typeBlock.row.appendChild(makePill(names[t] || t, 'type', t));
    });
    // La rangée Finition est reconstruite par rebuildFiniRow() dans render() — son contenu
    // dépend du type sélectionné (les ensembles fini d'Autocollant et de Traditionnel ne se
    // recoupent pas, contrairement au 1er jet où Lisse/Texturé étaient partagés par tous les types).

    var recap = document.createElement('p');
    recap.className = 'di-tier-recap';

    host.appendChild(typeBlock.wrap);
    host.appendChild(finiBlock.wrap);
    host.appendChild(recap);
    swatch.classList.add('di-tiers-on');

    var recapPrefix = host.getAttribute('data-label-selected') || 'Papier peint sélectionné:';

    function currentValue() {
      var checked = rawBox.querySelector('.swatchInput:checked');
      return checked ? checked.value : null;
    }

    function entryFor(value) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].value === value) return entries[i];
      }
      return null;
    }

    function selectValue(value) {
      var el = rawBox.querySelector('.swatch-element[data-value="' + window.CSS.escape(value) + '"]');
      if (!el) return;
      // On clique la radio, PAS le <label> : cliquer le label déclenche aussi un clic synthétique
      // sur la radio associée, donc le onclick du .swatch-element partait deux fois
      // (diSwatchElem appelé 2×, donc double changement de variante). Vérifié au banc d'essai
      // local le 2026-08-17. La radio coche nativement et le clic remonte une seule fois.
      var input = el.querySelector('.swatchInput');
      (input || el).click();
    }

    // Reconstruit la rangée Finition avec seulement les finis qui existent pour `type`
    // (contrairement au 1er jet, les ensembles fini ne se recoupent pas entre types —
    // pas de pilule "indisponible" à afficher en grisé, la rangée change complètement).
    var finiRowBuiltForType = null;
    function rebuildFiniRow(type) {
      if (type === finiRowBuiltForType) return;
      finiBlock.row.innerHTML = '';
      (FINI_ORDER_BY_TYPE[type] || []).forEach(function (f) {
        if (entries.some(function (e) { return e.type === type && e.fini === f; })) {
          finiBlock.row.appendChild(makePill(names[f] || f, 'fini', f));
        }
      });
      finiRowBuiltForType = type;
    }

    function render() {
      var current = entryFor(currentValue());
      var curType = current ? current.type : types[0];
      var curFini = current ? current.fini : null;

      rebuildFiniRow(curType);

      host.querySelectorAll('.di-tier-pill').forEach(function (pill) {
        var group = pill.getAttribute('data-di-group');
        var key = pill.getAttribute('data-di-key');
        pill.classList.toggle('is-selected', group === 'type' ? key === curType : key === curFini);
      });

      recap.textContent = current
        ? recapPrefix + ' ' + (names[curType] || curType) + ' — ' + (names[curFini] || curFini)
        : '';
    }

    host.addEventListener('click', function (ev) {
      var pill = ev.target.closest('.di-tier-pill');
      if (!pill || pill.disabled) return;
      ev.preventDefault();

      var group = pill.getAttribute('data-di-group');
      var key = pill.getAttribute('data-di-key');
      var current = entryFor(currentValue());
      var target = null;

      if (group === 'type') {
        // Les ensembles fini d'Autocollant (Lisse/Texturé) et de Traditionnel
        // (Fibreux/Satiné/Commercial) ne se recoupent pas — impossible de "garder" le fini
        // courant en changeant de type. On prend le premier fini disponible pour le type choisi.
        target = entries.filter(function (e) { return e.type === key; })[0];
      } else {
        var curType = current ? current.type : types[0];
        target = entries.filter(function (e) { return e.type === curType && e.fini === key; })[0];
      }

      if (target) selectValue(target.value);
      render();
    });

    // Resynchronise si la variante change ailleurs (select natif, deep link, retour arrière)
    document.querySelectorAll('.single-option-selector').forEach(function (sel) {
      sel.addEventListener('change', render);
    });
    rawBox.addEventListener('change', render);

    render();

    // ⚠️ Bug trouvé le 2026-08-30 en testant sur le vrai thème (pas reproductible dans le banc
    // d'essai local, qui simulait un radio déjà "checked" dans le HTML) : le HTML serveur ne
    // marque AUCUNE radio .swatchInput "checked" par défaut — c'est un script Shopify natif
    // (option_selection) qui coche la bonne radio après coup en assignant .checked directement,
    // sans déclencher d'événement "change". Notre 1er render() ci-dessus tombe donc souvent avant
    // ce moment : les pilules Fini s'affichent quand même (retombent sur types[0] par défaut),
    // mais le récap reste vide puisque `current` est encore introuvable. Un re-render après le
    // chargement complet de la page rattrape l'état une fois que ce script a fait son travail.
    window.addEventListener('load', render);
  }

  function boot() {
    // window.CSS.escape est requis pour les valeurs accentuées ; polyfill minimal si absent
    if (!window.CSS || typeof window.CSS.escape !== 'function') {
      window.CSS = window.CSS || {};
      window.CSS.escape = function (s) { return String(s).replace(/["\\]/g, '\\$&'); };
    }
    document.querySelectorAll('.di-matiere-tiers').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
